import React from "react";
import { SideMenu, SideMenuItem, SideMenuTop } from "../../../components/components/molecules/SideMenu";
import { useLocation } from "react-router-dom";
import PAGES from "../../../../../constants/pages";

interface NavigationItem {
    label: string;
    path: string;
}

const navigationItems: NavigationItem[] = [
    {
        label: "Provisjon",
        path: PAGES.RETAILER.SUPER_ADMIN.COMMISSION_ADMIN.URL,
    },
    {
        label: "Provisjonstall",
        path: PAGES.RETAILER.SUPER_ADMIN.COMMISSION_NUMBERS.URL,
    },
    {
        label: "Dokumenter",
        path: PAGES.RETAILER.SUPER_ADMIN.DOCUMENT_UPLOAD.URL,
    },
    {
        label: "Nyheter",
        path: PAGES.RETAILER.SUPER_ADMIN.NEWS_ADMIN.URL,
    },
    {
        label: "Vurderinger",
        path: PAGES.RETAILER.SUPER_ADMIN.FEEDBACK_ADMIN.URL,
    },
    {
        label: "Tilbakemeldinger",
        path: PAGES.RETAILER.SUPER_ADMIN.FEEDBACK_LIST.URL,
    },
];

const SuperAdminSidebar: React.FC = () => {
    const location = useLocation();

    return (
        <div className="sidebar">
            <SideMenu className="sidebar__menu">
                <SideMenuTop>
                    {navigationItems.map((item) => (
                        <SideMenuItem
                            label={item.label}
                            color="grey"
                            key={item.path}
                            onClick={() => window.location.assign(item.path)}
                            active={location.pathname === item.path}
                        />
                    ))}
                </SideMenuTop>
            </SideMenu>
        </div>
    );
};

export default SuperAdminSidebar;
